const getters = {
  isLoading: state => state.isLoading,
  list: state => state.list,
  isInvoiceLoading: state => state.isInvoiceLoading,
  invoicelist: state => state.invoicelist,
  isUploading: state => state.isUploading,
  isRejected: state => state.isRejected,
  uploadResponse: state => state.uploadResponse,
  isEmptyPaginate: state => state.isEmptyPaginate,
  filter: state => state.filter,
  hasEmpty: state => state.hasEmpty,
  tempCharges: state => state.tempCharges,
  indentDetails: state => state.indentDetails,
  dedicatedTruckMaster: state => state.dedicatedTruckMaster,
  invoiceDetails: state => state.invoiceDetails,
  totalSystemCharges: state => state.totalSystemCharges,
  totalTransporterCharges: state => state.totalTransporterCharges,
  transporterTotalFreightCharge: state => state.transporterTotalFreightCharge,
  freightBillDetails: state => state.freightBillDetails,
  freightBillCategories: state => state.freightBillCategories,
  totalIndentCount: state => state.totalIndentCount,
  isDedicatedTruck: state => state.isDedicatedTruck,
  depotWiseDetails: state => state.depotWiseDetails,
  selectedPaymentsList: state => state.selectedPaymentsList,
  paymentMovements: state => state.paymentMovements,
  proformaInvoiceNumber: state => state.proformaInvoiceNumber,
  invoiceApprovalSettings: state => state.invoiceApprovalSettings,
  invoiceLevelApprovalSettings: state => state.invoiceLevelApprovalSettings,
  selectedLegalEntity: state => state.selectedLegalEntity,
  isShipperChargesFeatureEnabled: state => state.isShipperChargesFeatureEnabled,
};

export default getters;
